jQuery(function ($) {
    $('.testimonials-slider').each(function () {
        $(this).slick({
            arrows: false,
            dots: true,
            slide: '.testimonial',
            appendDots: $('.testimonials-dots')
        });
    });
});